import script from "./Exam.vue?vue&type=script&setup=true&lang=js"
export * from "./Exam.vue?vue&type=script&setup=true&lang=js"

import "./Exam.vue?vue&type=style&index=0&id=61c1d154&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c1d154"]])

export default __exports__